import { TProcessId } from '@partners/types';
import { coerceNumber } from '@partners/utils';

/** converts process CODE to process NAME */
export function getProcessCode(processId: TProcessId): number {
  const pKeys = Object.keys(Process);
  const pValues = Object.values(Process);

  const index = pKeys.indexOf(processId);

  const code = pValues[index];

  return code;
}

/** converts process NAME to process CODE */
export function getProcessId(processCode: number): TProcessId {
  const pKeys = Object.keys(Process);
  const pValues = Object.values(Process);

  const index = pValues.indexOf(coerceNumber(processCode));

  const id = pKeys[index];

  return id as TProcessId;
}

export const Process: { [key in TProcessId]: number } = {
  card: 1 /* כרטיס אשראי */,
  loan: 2 /* הלוואה לפרטיים */,
  employer: 3 /* כרטיס מעסיק */,
  upsell: 4 /* מסגרת אפס */,
  bnpl: 5 /* הלוואה קנה עכשיו שלם אחר כך */,
  acfl: 2 /* הלוואה ללא כרטיס */
} as const;
